import React, { useState, useEffect } from 'react';
import { Formik, Form as FormikForm } from 'formik';
import * as Yup from 'yup';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { FaSave } from 'react-icons/fa';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';

const OPCOES_PIX_TIPO = [
  { value: '', label: '(nenhum)' },
  { value: 'C', label: 'CPF/CNPJ' },
  { value: 'T', label: 'Telefone' },
  { value: 'E', label: 'E-mail' },
  { value: 'A', label: 'Chave Aleatória' },
];

const OPCOES_SIM_NAO = [
  { value: 'S', label: 'Sim' },
  { value: 'N', label: 'Não' },
];

const OPCOES_TIPO_PAGTO = [
  { value: '', label: '(nenhum)' },
  { value: 'E', label: 'Empresa' },
  { value: 'C', label: 'Cliente' },
  { value: 'M', label: 'Mista (Cliente+Empresa)' },
  { value: 'A', label: 'Ambos' },
];

const OPCOES_CONTRATO = [
  { value: '1', label: '1 - Layout padrão Web - Setpar' },
  { value: '2', label: '2 - Layout padrão Web - Emais' },
  { value: '3', label: '3 - Layout Evendas / Res.Boulanger' },
  { value: '4', label: '4 - Layout padrão c/ juros 12% aa' },
  { value: '5', label: '5 - Layout padrão Web - MS' },
  { value: '6', label: '6 - Layout Golden Park II' },
  { value: '10', label: '10 - Contrato Configurado' },
];

const OPCOES_TIPO_TABELA = [
  { value: '', label: '(nenhum)' },
  { value: '1', label: '1 - Sinal Empresa' },
  { value: '2', label: '2 - Sinal Parceiro' },
  { value: '3', label: '3 - Sinal Evendas Parcelado' },
  { value: '4', label: '4 - Sinal Evendas Parcelado 2' },
];

const OPCOES_CB_TIPO = [
  { value: '', label: '(nenhum)' },
  { value: 'V', label: 'Valor' },
  { value: 'P', label: 'Percentual' },
];

const OPCOES_CB_SOBRE = [
  { value: '', label: '(nenhum)' },
  { value: 'V', label: 'VV' },
  { value: 'C', label: 'Contrato' },
];

const OPCOES_FCOMISSAO = [
  { value: '', label: '(nenhum)' },
  { value: '1', label: '1-Cad.Rápido' },
  { value: '2', label: '2-Aguardo Proposta' },
  { value: '3', label: '3-Pré Venda - Gravar' },
  { value: '4', label: '4-Pré Venda - Efetivar' },
  { value: '5', label: '5-Emissão Contrato' },
  { value: '6', label: '6-Aguard. Ass.Cliente' },
  { value: '7', label: '7-Aguardando Diretoria' },
  { value: '8', label: '8-Aguard.Quitar Sinal' },
  { value: '9', label: '9-Env.Contrato Cliente' },
];

const LABELS_FASES = {
  f1: '1-Cad.Rápido',
  f2: '2-Aguardo Proposta',
  f3: '3-Pré Venda - Gravar',
  f4: '4-Pré Venda - Efetivar',
  f5: '5-Emissão Contrato',
  f6: '6-Aguard. Ass.Cliente',
  f7: '7-Aguardando Diretoria',
  f8: '8-Aguard.Quitar Sinal',
  f9: '9-Env.Contrato Cliente',
};

const schema = Yup.object({
  sinal_minimo: Yup.number()
    .typeError('% Sinal Mínimo inválido')
    .min(0, 'Valor mínimo é 0')
    .max(100, 'Valor máximo é 100'),
  sinal_maximo: Yup.number()
    .typeError('% Sinal Máximo inválido')
    .min(0, 'Valor mínimo é 0')
    .max(100, 'Valor máximo é 100')
    .test('maximo-maior-minimo', '% Máximo deve ser >= % Mínimo', function (val) {
      const min = this.parent.sinal_minimo;
      if (val == null || min == null) return true;
      return Number(val) >= Number(min);
    }),
});

const findOpt = (opts, val) => {
  const found = opts.find((o) => o.value === val);
  return found != null ? found : null;
};

const SelectField = ({ name, options, value, disabled, onChange }) => (
  <Select
    options={options}
    value={findOpt(options, value)}
    onChange={(opt) => onChange(name, opt != null ? opt.value : '')}
    isDisabled={disabled}
    styles={customStyles}
    components={{ DropdownIndicator }}
    menuPortalTarget={document.body}
  />
);

const FormConfigVendas = ({ dados, permissoes, onSalvar }) => {
  const disabled = !permissoes.adm_vendas;
  const [usuarioOptions, setUsuarioOptions] = useState([]);

  useEffect(() => {
    api.buscarUsuarioOptions('ativos')
      .then((res) => {
        const lista = res && res.data ? res.data : (res || []);
        const opts = (Array.isArray(lista) ? lista : []).map((u) => ({
          value: u.codigo != null ? u.codigo : u.codigo_usuario,
          label: (u.codigo != null ? u.codigo : u.codigo_usuario) + ' - ' + (u.nome != null ? u.nome : u.nome_usuario),
        }));
        setUsuarioOptions(opts);
      })
      .catch(() => { /* silencioso */ });
  }, []);

  const initialValues = {
    codigo_familia: dados != null ? dados.codigo_familia : '',
    financ_banco: dados != null && dados.financ_banco != null ? dados.financ_banco : '',
    financ_agencia:
      dados != null && dados.financ_agencia != null ? dados.financ_agencia : '',
    financ_conta: dados != null && dados.financ_conta != null ? dados.financ_conta : '',
    financ_operacao:
      dados != null && dados.financ_operacao != null ? dados.financ_operacao : '',
    boleto_banco: dados != null && dados.boleto_banco != null ? dados.boleto_banco : '',
    boleto_agencia:
      dados != null && dados.boleto_agencia != null ? dados.boleto_agencia : '',
    boleto_conta: dados != null && dados.boleto_conta != null ? dados.boleto_conta : '',
    boleto_carteira:
      dados != null && dados.boleto_carteira != null ? dados.boleto_carteira : '',
    pix_tipo: dados != null && dados.pix_tipo != null ? dados.pix_tipo : '',
    pix_chave: dados != null && dados.pix_chave != null ? dados.pix_chave : '',
    sinal_minimo: dados != null && dados.sinal_minimo != null ? dados.sinal_minimo : '',
    sinal_maximo: dados != null && dados.sinal_maximo != null ? dados.sinal_maximo : '',
    estoque_extranet:
      dados != null && dados.estoque_extranet != null ? dados.estoque_extranet : 'N',
    comp_data_limite:
      dados != null && dados.comp_data_limite != null ? dados.comp_data_limite : '',
    acr_data_limite:
      dados != null && dados.acr_data_limite != null ? dados.acr_data_limite : '',
    // Financiamento
    financ_tipo_conta:
      dados != null && dados.financ_tipo_conta != null ? dados.financ_tipo_conta : '',
    // Sinal / Entrada
    sinal_banco: dados != null && dados.sinal_banco != null ? dados.sinal_banco : '',
    sinal_agencia:
      dados != null && dados.sinal_agencia != null ? dados.sinal_agencia : '',
    sinal_conta: dados != null && dados.sinal_conta != null ? dados.sinal_conta : '',
    dias_avista: dados != null && dados.dias_avista != null ? dados.dias_avista : '',
    // Boleto
    texto_boleto:
      dados != null && dados.texto_boleto != null ? dados.texto_boleto : '',
    libera_boleto:
      dados != null && dados.libera_boleto != null ? dados.libera_boleto : 'N',
    dias_minimo_boleto:
      dados != null && dados.dias_minimo_boleto != null ? dados.dias_minimo_boleto : '',
    sugestao_dias_boleto_sinal:
      dados != null && dados.sugestao_dias_boleto_sinal != null
        ? dados.sugestao_dias_boleto_sinal
        : '',
    // Fases Adm. Vendas
    f1: dados != null && dados.f1 === 'S',
    f2: dados != null && dados.f2 === 'S',
    f3: dados != null && dados.f3 === 'S',
    f4: dados != null && dados.f4 === 'S',
    f5: dados != null && dados.f5 === 'S',
    f6: dados != null && dados.f6 === 'S',
    f7: dados != null && dados.f7 === 'S',
    f8: dados != null && dados.f8 === 'S',
    f9: dados != null && dados.f9 === 'S',
    // Comprovante / Acréscimo
    comp_venda: dados != null && dados.comp_venda != null ? dados.comp_venda : '',
    comp_prospecto:
      dados != null && dados.comp_prospecto != null ? dados.comp_prospecto : '',
    comp_venda_pasta:
      dados != null && dados.comp_venda_pasta != null ? dados.comp_venda_pasta : '',
    comp_prospecto_pasta:
      dados != null && dados.comp_prospecto_pasta != null ? dados.comp_prospecto_pasta : '',
    // Configurações de Venda
    gera_auto: dados != null && dados.gera_auto != null ? dados.gera_auto : 'N',
    lote_disp_cx:
      dados != null && dados.lote_disp_cx != null ? dados.lote_disp_cx : 'N',
    tipo_pagto: dados != null && dados.tipo_pagto != null ? dados.tipo_pagto : '',
    vda_ticket: dados != null && dados.vda_ticket != null ? dados.vda_ticket : 'N',
    caixa_lanc: dados != null && dados.caixa_lanc != null ? dados.caixa_lanc : 'N',
    venda_com_comissao:
      dados != null && dados.venda_com_comissao != null ? dados.venda_com_comissao : 'N',
    lanca_venda:
      dados != null && dados.lanca_venda != null ? dados.lanca_venda : 'N',
    // Pré-Venda / Documentos
    fila: dados != null && dados.fila != null ? dados.fila : 'N',
    senha_pre_venda:
      dados != null && dados.senha_pre_venda != null ? dados.senha_pre_venda : '',
    impressao_web:
      dados != null && dados.impressao_web != null ? dados.impressao_web : 'N',
    pd_funico: dados != null && dados.pd_funico != null ? dados.pd_funico : 'N',
    envelope: dados != null && dados.envelope != null ? dados.envelope : 'N',
    controla_incorp:
      dados != null && dados.controla_incorp != null ? dados.controla_incorp : 'N',
    protocolar: dados != null && dados.protocolar != null ? dados.protocolar : 'N',
    // Comissão
    rec_comissao_int1:
      dados != null && dados.rec_comissao_int1 != null ? dados.rec_comissao_int1 : '',
    rec_comissao_int2:
      dados != null && dados.rec_comissao_int2 != null ? dados.rec_comissao_int2 : '',
    rec_comissao_int3:
      dados != null && dados.rec_comissao_int3 != null ? dados.rec_comissao_int3 : '',
    rec_comissao_int4:
      dados != null && dados.rec_comissao_int4 != null ? dados.rec_comissao_int4 : '',
    rec_comissao_int5:
      dados != null && dados.rec_comissao_int5 != null ? dados.rec_comissao_int5 : '',
    rec_comissao_int6:
      dados != null && dados.rec_comissao_int6 != null ? dados.rec_comissao_int6 : '',
    rec_comissao_int7:
      dados != null && dados.rec_comissao_int7 != null ? dados.rec_comissao_int7 : '',
    estorna_toda_comissao:
      dados != null && dados.estorna_toda_comissao != null
        ? dados.estorna_toda_comissao
        : 'N',
    // Cheque Bônus
    cb_data_limite:
      dados != null && dados.cb_data_limite != null ? dados.cb_data_limite : '',
    cb_valor: dados != null && dados.cb_valor != null ? dados.cb_valor : '',
    cb_tipo: dados != null && dados.cb_tipo != null ? dados.cb_tipo : '',
    cb_sobre: dados != null && dados.cb_sobre != null ? dados.cb_sobre : '',
    // Multa / Taxa
    multa_pg: dados != null && dados.multa_pg != null ? dados.multa_pg : '',
    multa_vda: dados != null && dados.multa_vda != null ? dados.multa_vda : '',
    tp_multa_res:
      dados != null && dados.tp_multa_res != null ? dados.tp_multa_res : '',
    // Centro Receita / Início Pagamento Comissão
    centro_receita: dados != null && dados.centro_receita != null ? dados.centro_receita : '',
    f_comissao: dados != null && dados.f_comissao != null ? String(dados.f_comissao) : '',
    // Restrição
    trava_restricao:
      dados != null && dados.trava_restricao != null ? dados.trava_restricao : 'N',
    usu_rest: dados != null && dados.usu_rest != null ? dados.usu_rest : '',
    email_rest: dados != null && dados.email_rest != null ? dados.email_rest : '',
    r_especial: dados != null && dados.r_especial != null ? dados.r_especial : 'N',
    // Carência / Correção
    qtd_dia_carencia_fin:
      dados != null && dados.qtd_dia_carencia_fin != null ? dados.qtd_dia_carencia_fin : '',
    qtd_dia_min_carencia:
      dados != null && dados.qtd_dia_min_carencia != null ? dados.qtd_dia_min_carencia : '',
    qtd_dia_carencia_sinal:
      dados != null && dados.qtd_dia_carencia_sinal != null
        ? dados.qtd_dia_carencia_sinal
        : '',
    // Redutor / IPTU
    redutor_automatico:
      dados != null && dados.redutor_automatico != null ? dados.redutor_automatico : 'N',
    data_limite_taxa_reduzida:
      dados != null && dados.data_limite_taxa_reduzida != null
        ? dados.data_limite_taxa_reduzida
        : '',
    balao_ate: dados != null && dados.balao_ate != null ? dados.balao_ate : '',
    imprime_iptu:
      dados != null && dados.imprime_iptu != null ? dados.imprime_iptu : 'N',
    // E-mail
    email_imob: dados != null && dados.email_imob != null ? dados.email_imob : '',
    // Texto Padrão
    texto_padrao_contato:
      dados != null && dados.texto_padrao_contato != null ? dados.texto_padrao_contato : '',
    // Campos Adm. Vendas
    int_vendas: dados != null && dados.int_vendas != null ? dados.int_vendas : 'N',
    int_ini: dados != null && dados.int_ini != null ? dados.int_ini : '',
    int_fim: dados != null && dados.int_fim != null ? dados.int_fim : '',
    tipo_tabela: dados != null && dados.tipo_tabela != null ? String(dados.tipo_tabela) : '',
    contrato: dados != null && dados.contrato != null ? String(dados.contrato) : '',
    check_list: dados != null && dados.check_list != null ? dados.check_list : 'N',
    check_in: dados != null && dados.check_in != null ? dados.check_in : 'N',
    central: dados != null && dados.central != null ? dados.central : 'N',
    cldb: dados != null && dados.cldb != null ? dados.cldb : 'N',
    lista_emp_fale_conosco:
      dados != null && dados.lista_emp_fale_conosco != null ? dados.lista_emp_fale_conosco : 'N',
    lista_emp_ma:
      dados != null && dados.lista_emp_ma != null ? dados.lista_emp_ma : 'N',
    layout_proposta:
      dados != null && dados.layout_proposta != null ? dados.layout_proposta : '',
    fim_campanha:
      dados != null && dados.fim_campanha != null ? dados.fim_campanha : '',
    per_ent_incorp_semtabela:
      dados != null && dados.per_ent_incorp_semtabela != null
        ? dados.per_ent_incorp_semtabela
        : '',
    local_contrato:
      dados != null && dados.local_contrato != null ? dados.local_contrato : '',
    local_cancela:
      dados != null && dados.local_cancela != null ? dados.local_cancela : '',
    local_renuncia:
      dados != null && dados.local_renuncia != null ? dados.local_renuncia : '',
    clausula: dados != null && dados.clausula != null ? dados.clausula : '',
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      enableReinitialize
      onSubmit={(values) => {
        const payload = { ...values };
        ['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9'].forEach((f) => {
          payload[f] = payload[f] ? 'S' : 'N';
        });
        onSalvar(payload);
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
        <FormikForm>
          {/* Seção Financiamento */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Financiamento</legend>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Banco</Form.Label>
                  <Form.Control
                    size="sm"
                    name="financ_banco"
                    value={values.financ_banco}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Agência</Form.Label>
                  <Form.Control
                    size="sm"
                    name="financ_agencia"
                    value={values.financ_agencia}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Conta</Form.Label>
                  <Form.Control
                    size="sm"
                    name="financ_conta"
                    value={values.financ_conta}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">
                    Operação
                    {values.financ_banco === '104' && (
                      <span className="text-danger ml-1">*</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    size="sm"
                    name="financ_operacao"
                    value={values.financ_operacao}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Tipo Conta</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="financ_tipo_conta"
                    value={values.financ_tipo_conta}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Boleto */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Boleto</legend>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Banco</Form.Label>
                  <Form.Control
                    size="sm"
                    name="boleto_banco"
                    value={values.boleto_banco}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Agência</Form.Label>
                  <Form.Control
                    size="sm"
                    name="boleto_agencia"
                    value={values.boleto_agencia}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Conta</Form.Label>
                  <Form.Control
                    size="sm"
                    name="boleto_conta"
                    value={values.boleto_conta}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Carteira</Form.Label>
                  <Form.Control
                    size="sm"
                    name="boleto_carteira"
                    value={values.boleto_carteira}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Libera Boleto</Form.Label>
                  <SelectField
                    name="libera_boleto"
                    options={OPCOES_SIM_NAO}
                    value={values.libera_boleto}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="small mb-1">Texto Boleto</Form.Label>
                  <Form.Control
                    size="sm"
                    name="texto_boleto"
                    value={values.texto_boleto}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Dias Mín. Boleto</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="dias_minimo_boleto"
                    value={values.dias_minimo_boleto}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Sugestão Dias Bol. Sinal</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="sugestao_dias_boleto_sinal"
                    value={values.sugestao_dias_boleto_sinal}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Tipo PIX</Form.Label>
                  <SelectField
                    name="pix_tipo"
                    options={OPCOES_PIX_TIPO}
                    value={values.pix_tipo}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="small mb-1">Chave PIX</Form.Label>
                  <Form.Control
                    size="sm"
                    name="pix_chave"
                    value={values.pix_chave}
                    onChange={handleChange}
                    disabled={disabled || !values.pix_tipo}
                    placeholder={values.pix_tipo ? 'Informe a chave' : '(selecione o tipo)'}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Sinal/Entrada */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Sinal / Entrada</legend>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">% Sinal Mínimo</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    name="sinal_minimo"
                    value={values.sinal_minimo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={disabled}
                    isInvalid={touched.sinal_minimo && !!errors.sinal_minimo}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.sinal_minimo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">% Sinal Máximo</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    name="sinal_maximo"
                    value={values.sinal_maximo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={disabled}
                    isInvalid={touched.sinal_maximo && !!errors.sinal_maximo}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.sinal_maximo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Banco Sinal</Form.Label>
                  <Form.Control
                    size="sm"
                    name="sinal_banco"
                    value={values.sinal_banco}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Agência Sinal</Form.Label>
                  <Form.Control
                    size="sm"
                    name="sinal_agencia"
                    value={values.sinal_agencia}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Conta Sinal</Form.Label>
                  <Form.Control
                    size="sm"
                    name="sinal_conta"
                    value={values.sinal_conta}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Dias À Vista</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="dias_avista"
                    value={values.dias_avista}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Estoque/Extranet */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Estoque / Extranet</legend>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Exibir na Extranet</Form.Label>
                  <SelectField
                    name="estoque_extranet"
                    options={OPCOES_SIM_NAO}
                    value={values.estoque_extranet}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Comprovante/Acréscimo */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Comprovante / Acréscimo</legend>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Limite Comprovante</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    name="comp_data_limite"
                    value={values.comp_data_limite}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Limite Acréscimo</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    name="acr_data_limite"
                    value={values.acr_data_limite}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">% Comp. Venda</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    name="comp_venda"
                    value={values.comp_venda}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">% Comp. Prospecto</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    name="comp_prospecto"
                    value={values.comp_prospecto}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">% Comp. Venda Pasta</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    name="comp_venda_pasta"
                    value={values.comp_venda_pasta}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">% Comp. Prosp. Pasta</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    name="comp_prospecto_pasta"
                    value={values.comp_prospecto_pasta}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Configurações de Venda */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Configurações de Venda</legend>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Gera Auto</Form.Label>
                  <SelectField
                    name="gera_auto"
                    options={OPCOES_SIM_NAO}
                    value={values.gera_auto}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Lote Disp. CX</Form.Label>
                  <SelectField
                    name="lote_disp_cx"
                    options={OPCOES_SIM_NAO}
                    value={values.lote_disp_cx}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Tipo Pagto</Form.Label>
                  <SelectField
                    name="tipo_pagto"
                    options={OPCOES_TIPO_PAGTO}
                    value={values.tipo_pagto}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Vda. Ticket</Form.Label>
                  <SelectField
                    name="vda_ticket"
                    options={OPCOES_SIM_NAO}
                    value={values.vda_ticket}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Caixa Lanç.</Form.Label>
                  <SelectField
                    name="caixa_lanc"
                    options={OPCOES_SIM_NAO}
                    value={values.caixa_lanc}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Venda c/ Comissão</Form.Label>
                  <SelectField
                    name="venda_com_comissao"
                    options={OPCOES_SIM_NAO}
                    value={values.venda_com_comissao}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Lança Venda</Form.Label>
                  <SelectField
                    name="lanca_venda"
                    options={OPCOES_SIM_NAO}
                    value={values.lanca_venda}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Pré-Venda / Documentos */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Pré-Venda / Documentos</legend>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Fila</Form.Label>
                  <SelectField
                    name="fila"
                    options={OPCOES_SIM_NAO}
                    value={values.fila}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Senha Pré-Venda</Form.Label>
                  <Form.Control
                    size="sm"
                    name="senha_pre_venda"
                    value={values.senha_pre_venda}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Impressão Web</Form.Label>
                  <SelectField
                    name="impressao_web"
                    options={OPCOES_SIM_NAO}
                    value={values.impressao_web}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">PDF Único</Form.Label>
                  <SelectField
                    name="pd_funico"
                    options={OPCOES_SIM_NAO}
                    value={values.pd_funico}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Envelope</Form.Label>
                  <SelectField
                    name="envelope"
                    options={OPCOES_SIM_NAO}
                    value={values.envelope}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Controla Incorp.</Form.Label>
                  <SelectField
                    name="controla_incorp"
                    options={OPCOES_SIM_NAO}
                    value={values.controla_incorp}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Protocolar</Form.Label>
                  <SelectField
                    name="protocolar"
                    options={OPCOES_SIM_NAO}
                    value={values.protocolar}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Comissão */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Comissão</legend>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Rec. Com. Int. 1</Form.Label>
                  <Form.Control
                    size="sm"
                    name="rec_comissao_int1"
                    value={values.rec_comissao_int1}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Rec. Com. Int. 2</Form.Label>
                  <Form.Control
                    size="sm"
                    name="rec_comissao_int2"
                    value={values.rec_comissao_int2}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Rec. Com. Int. 3</Form.Label>
                  <Form.Control
                    size="sm"
                    name="rec_comissao_int3"
                    value={values.rec_comissao_int3}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Rec. Com. Int. 4</Form.Label>
                  <Form.Control
                    size="sm"
                    name="rec_comissao_int4"
                    value={values.rec_comissao_int4}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Rec. Com. Int. 5</Form.Label>
                  <Form.Control
                    size="sm"
                    name="rec_comissao_int5"
                    value={values.rec_comissao_int5}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Rec. Com. Int. 6</Form.Label>
                  <Form.Control
                    size="sm"
                    name="rec_comissao_int6"
                    value={values.rec_comissao_int6}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Rec. Com. Int. 7</Form.Label>
                  <Form.Control
                    size="sm"
                    name="rec_comissao_int7"
                    value={values.rec_comissao_int7}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Estorna Toda Comissão</Form.Label>
                  <SelectField
                    name="estorna_toda_comissao"
                    options={OPCOES_SIM_NAO}
                    value={values.estorna_toda_comissao}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Cheque Bônus */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Cheque Bônus</legend>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Data Limite CB</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    name="cb_data_limite"
                    value={values.cb_data_limite}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Valor CB</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    name="cb_valor"
                    value={values.cb_valor}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Tipo CB</Form.Label>
                  <SelectField
                    name="cb_tipo"
                    options={OPCOES_CB_TIPO}
                    value={values.cb_tipo}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">CB Sobre</Form.Label>
                  <SelectField
                    name="cb_sobre"
                    options={OPCOES_CB_SOBRE}
                    value={values.cb_sobre}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Multa / Taxa */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Multa / Taxa</legend>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Multa Pg</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    name="multa_pg"
                    value={values.multa_pg}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Multa Vda</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    name="multa_vda"
                    value={values.multa_vda}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Tipo Multa Res.</Form.Label>
                  <Form.Control
                    size="sm"
                    name="tp_multa_res"
                    value={values.tp_multa_res}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Restrição */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Restrição</legend>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Trava Restrição</Form.Label>
                  <SelectField
                    name="trava_restricao"
                    options={OPCOES_SIM_NAO}
                    value={values.trava_restricao}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Usuário Rest.</Form.Label>
                  <Select
                    options={usuarioOptions}
                    value={usuarioOptions.find((o) => o.value === values.usu_rest) || null}
                    onChange={(opt) => { setFieldValue('usu_rest', opt != null ? opt.value : ''); }}
                    isDisabled={disabled}
                    isClearable
                    placeholder="Selecione..."
                    styles={customStyles}
                    components={{ DropdownIndicator: DropdownIndicator }}
                    menuPortalTarget={document.body}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="small mb-1">E-mail Restrição</Form.Label>
                  <Form.Control
                    size="sm"
                    type="email"
                    name="email_rest"
                    value={values.email_rest}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">R. Especial</Form.Label>
                  <SelectField
                    name="r_especial"
                    options={OPCOES_SIM_NAO}
                    value={values.r_especial}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Carência / Correção */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Carência / Correção</legend>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Dias Carência Fin.</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="qtd_dia_carencia_fin"
                    value={values.qtd_dia_carencia_fin}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Dias Mín. Carência</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="qtd_dia_min_carencia"
                    value={values.qtd_dia_min_carencia}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Dias Carência Sinal</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="qtd_dia_carencia_sinal"
                    value={values.qtd_dia_carencia_sinal}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Redutor / IPTU */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Redutor / IPTU</legend>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Redutor Automático</Form.Label>
                  <SelectField
                    name="redutor_automatico"
                    options={OPCOES_SIM_NAO}
                    value={values.redutor_automatico}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Dt. Limite Taxa Red.</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    name="data_limite_taxa_reduzida"
                    value={values.data_limite_taxa_reduzida}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Balão Até</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    name="balao_ate"
                    value={values.balao_ate}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Imprime IPTU</Form.Label>
                  <SelectField
                    name="imprime_iptu"
                    options={OPCOES_SIM_NAO}
                    value={values.imprime_iptu}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção E-mail */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">E-mail</legend>
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="small mb-1">E-mail Imob.</Form.Label>
                  <Form.Control
                    size="sm"
                    type="email"
                    name="email_imob"
                    value={values.email_imob}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Texto Padrão */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Texto Padrão</legend>
            <Row>
              <Col md={12}>
                <Form.Group>
                  <Form.Label className="small mb-1">Texto Padrão Contato</Form.Label>
                  <Form.Control
                    size="sm"
                    as="textarea"
                    rows={3}
                    name="texto_padrao_contato"
                    value={values.texto_padrao_contato}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Fases Administração de Vendas</legend>
            <Row>
              <Col md={12}>
                <div className="d-flex flex-wrap" style={{ gap: '14px' }}>
                  {['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9'].map((f) => (
                    <Form.Check
                      key={f}
                      type="checkbox"
                      id={`check-cv-${f}`}
                      label={LABELS_FASES[f]}
                      name={f}
                      checked={values[f]}
                      onChange={handleChange}
                      disabled={disabled}
                    />
                  ))}
                </div>
              </Col>
            </Row>
          </fieldset>

          {/* Seção Adm. Vendas */}
          <fieldset className="mb-4">
            <legend className="h6 border-bottom pb-1 mb-3">Adm. Vendas</legend>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Centro Receita</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="centro_receita"
                    value={values.centro_receita}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Início Pgto Comissão</Form.Label>
                  <SelectField
                    name="f_comissao"
                    options={OPCOES_FCOMISSAO}
                    value={values.f_comissao}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Int. Vendas</Form.Label>
                  <SelectField
                    name="int_vendas"
                    options={OPCOES_SIM_NAO}
                    value={values.int_vendas}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Int. Inicial</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="int_ini"
                    value={values.int_ini}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Int. Final</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="int_fim"
                    value={values.int_fim}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Tipo Tabela</Form.Label>
                  <SelectField
                    name="tipo_tabela"
                    options={OPCOES_TIPO_TABELA}
                    value={values.tipo_tabela}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Contrato</Form.Label>
                  <SelectField
                    name="contrato"
                    options={OPCOES_CONTRATO}
                    value={values.contrato}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Layout Proposta</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="layout_proposta"
                    value={values.layout_proposta}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">CheckList</Form.Label>
                  <SelectField
                    name="check_list"
                    options={OPCOES_SIM_NAO}
                    value={values.check_list}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">CheckIn</Form.Label>
                  <SelectField
                    name="check_in"
                    options={OPCOES_SIM_NAO}
                    value={values.check_in}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Central</Form.Label>
                  <SelectField
                    name="central"
                    options={OPCOES_SIM_NAO}
                    value={values.central}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">CLDB</Form.Label>
                  <SelectField
                    name="cldb"
                    options={OPCOES_SIM_NAO}
                    value={values.cldb}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Fale Conosco</Form.Label>
                  <SelectField
                    name="lista_emp_fale_conosco"
                    options={OPCOES_SIM_NAO}
                    value={values.lista_emp_fale_conosco}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">M.A.</Form.Label>
                  <SelectField
                    name="lista_emp_ma"
                    options={OPCOES_SIM_NAO}
                    value={values.lista_emp_ma}
                    disabled={disabled}
                    onChange={setFieldValue}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">% Ent. Incorp. s/ Tabela</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    name="per_ent_incorp_semtabela"
                    value={values.per_ent_incorp_semtabela}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Fim Campanha</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    name="fim_campanha"
                    value={values.fim_campanha}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Local Contrato</Form.Label>
                  <Form.Control
                    size="sm"
                    name="local_contrato"
                    value={values.local_contrato}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Local Cancela</Form.Label>
                  <Form.Control
                    size="sm"
                    name="local_cancela"
                    value={values.local_cancela}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Local Renúncia</Form.Label>
                  <Form.Control
                    size="sm"
                    name="local_renuncia"
                    value={values.local_renuncia}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="small mb-1">Cláusulas</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="clausula"
                    value={values.clausula}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </Form.Group>
              </Col>
            </Row>
          </fieldset>

          <div className="text-right mt-3">
            <Button type="submit" variant="success" size="sm">
              <FaSave className="mr-1" /> Salvar Config. Vendas
            </Button>
          </div>
        </FormikForm>
      )}
    </Formik>
  );
};

export default FormConfigVendas;
